import firebase from 'firebase/app';
import 'firebase/firestore';
import { queries } from 'procura-shared';

export const config = {
  apiKey: 'AIzaSyCe9yHs_I03jwTU1MeKvFcLQWNqNxVSLrM',
  authDomain: 'procuragroup-7e3c6.firebaseapp.com',
  databaseURL: 'https://procuragroup-7e3c6.firebaseio.com',
  projectId: 'procuragroup-7e3c6',
  storageBucket: 'procuragroup-7e3c6.appspot.com',
  messagingSenderId: '598498178370',
  appId: '1:598498178370:web:e6feefb3dd6590b62cc4db',
  measurementId: 'G-TMK9X1HF7J',
  apiEndpoint: 'https://europe-west1-procuragroup-7e3c6.cloudfunctions.net',
};

firebase.initializeApp(config);
queries.initFirestore(firebase.firestore());

export default firebase;
